import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

const AdminValues = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.Container}>
      <h1>{t('adminValuesPage.featureNotReadyYet')}</h1>
    </div>
  );
};

export default AdminValues;
